import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';
import { AlertTriangle, X } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const PaymentWarningBanner = () => {
  const { user } = useAuth();
  const [status, setStatus] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    if (!user?.dealer_id) return;
    const fetchStatus = async () => {
      try {
        const res = await axios.get(`${API}/payment-status/${user.dealer_id}`, {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        });
        if (res.data.payment_status === 'overdue') {
          setStatus(res.data);
        }
      } catch {}
    };
    fetchStatus();
  }, [user?.dealer_id]);

  if (!status || dismissed) return null;

  const days = status.days_remaining ?? 0;

  return (
    <div
      className="w-full px-4 py-3 flex items-center justify-between gap-3"
      style={{ backgroundColor: '#fef3c7', borderBottom: '2px solid #f59e0b' }}
      data-testid="payment-warning-banner"
    >
      <div className="flex items-center gap-3">
        <AlertTriangle className="w-5 h-5 shrink-0" style={{ color: '#92400e' }} />
        <span className="text-sm font-medium" style={{ color: '#92400e' }}>
          Paiement en retard — {days} jour{days !== 1 ? 's' : ''} restant{days !== 1 ? 's' : ''} avant suspension automatique.
        </span>
      </div>
      <button
        onClick={() => setDismissed(true)}
        className="p-1 rounded hover:bg-yellow-300/50 transition-colors"
        data-testid="dismiss-payment-warning"
      >
        <X className="w-4 h-4" style={{ color: '#92400e' }} />
      </button>
    </div>
  );
};

export default PaymentWarningBanner;
